import useCheckToken from 'utils/useCheckToken'

export default function NeedAuth({ children }) {

    useCheckToken()

    return (
        <>
            {children}
        </>
    )
}
